import { track } from '@mc/track-event'
import {
  ActionTypes,
  FUNNEL_STATE_ID,
  KeyTypes,
  saveUserData,
} from '@mc/user-data'
import { CheckoutEvents } from '../../lib/constants'
import {
  CheckoutPaymentMethodSelectedEventProps,
  CheckoutStepCompletedEventProps,
  CheckoutStepOneCompletedEventProps,
  CheckoutStepThreeCompletedEventProps,
  CheckoutStepTwoCompletedEventProps,
} from '../../types/CheckoutStepCompletedEventProps'

const trackCheckoutStepOneCompleted = ({
  productName,
  pageSource,
}: CheckoutStepOneCompletedEventProps) => {
  track(CheckoutEvents.EVENTS.CHECKOUT_STEP_COMPLETED, {
    page_category: 'checkout',
    product_name: productName,
    page_source: pageSource,
    step: 1,
    step_name: 'product_selection',
  })
}

const trackCheckoutStepTwoCompleted = ({
  productName,
  pageSource,
  action,
  modalType,
}: CheckoutStepTwoCompletedEventProps) => {
  track(CheckoutEvents.EVENTS.CHECKOUT_STEP_COMPLETED, {
    page_category: 'checkout',
    product_name: productName,
    page_source: pageSource,
    step: 2,
    step_name: 'email_submission',
    location: 'falcon_cart',
    action,
    ...(modalType && { modal_type: modalType }),
  })

  saveUserData({
    key: KeyTypes.FUNNEL_STATE,
    id: FUNNEL_STATE_ID,
    actionType: ActionTypes.USER_CREATED_ACCOUNT,
    eventName: CheckoutEvents.EVENTS.CHECKOUT_STEP_COMPLETED,
  })
}

const trackCheckoutStepThreeCompleted = ({
  productName,
  pageSource,
  action,
  modalType,
  paymentProvider,
}: CheckoutStepThreeCompletedEventProps) => {
  track(CheckoutEvents.EVENTS.CHECKOUT_STEP_COMPLETED, {
    page_category: 'checkout',
    product_name: productName,
    page_source: pageSource,
    step: 3,
    step_name: 'payment',
    action,
    location: 'falcon_cart',
    payment_provider: paymentProvider,
    ...(modalType && { modal_type: modalType }),
  })

  saveUserData({
    key: KeyTypes.FUNNEL_STATE,
    id: FUNNEL_STATE_ID,
    actionType: ActionTypes.USER_CLICKED_PLACE_SECURE_ORDER,
    eventName: CheckoutEvents.EVENTS.CHECKOUT_STEP_COMPLETED,
  })
}

export const trackCheckoutStepCompleted = ({
  step,
  productName,
  pageSource,
  stepTwoProps,
  stepThreeProps,
}: CheckoutStepCompletedEventProps) => {
  switch (step) {
    case 1:
      trackCheckoutStepOneCompleted({ step, productName, pageSource })
      break
    case 2:
      if (stepTwoProps) {
        trackCheckoutStepTwoCompleted({
          step,
          productName,
          pageSource,
          ...stepTwoProps,
        })
      }
      break
    case 3:
      if (stepThreeProps) {
        trackCheckoutStepThreeCompleted({
          step,
          productName,
          pageSource,
          ...stepThreeProps,
        })
      }
      break
    default:
      throw new Error('Unsupported step')
  }
}

export const trackCheckoutPaymentMethodSelected = ({
  productName,
  pageSource,
  paymentProvider,
}: CheckoutPaymentMethodSelectedEventProps) => {
  track(CheckoutEvents.EVENTS.CHECKOUT_STEP_COMPLETED, {
    page_category: 'checkout',
    product_name: productName,
    page_source: pageSource,
    step: 3,
    step_name: 'payment_method_selection',
    location: 'falcon_cart',
    payment_provider: paymentProvider,
  })
}

export const trackCheckoutMultiGiftStepCompleted = ({
  productName,
  pageSource,
  quantity,
  step,
}: CheckoutStepOneCompletedEventProps & {
  quantity: number
}) => {
  track(CheckoutEvents.EVENTS.CHECKOUT_STEP_COMPLETED, {
    step,
    productName,
    productType: 'gift',
    quantity,
    page_source: pageSource,
    step_name: 'multi_gift_added',
  })
}
